import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-exempt-vendor-types-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './exempt-vendor-types-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExemptVendorTypesGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private CompanyService: CompanyService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'ExemptVendorType';
    this.rowModelType = 'serverSide';

    this.additionalQueryData = {
      attributes: ['id']
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.CompanyService.getCompanyExemptVendorTypes(queryObject),
          this.CompanyService.getCompanyExemptVendorTypeCount(countQueryObject)
        ]).subscribe({
          next: ([ExemptVendorTypes, exemptVendorTypeCount]) => {
            params.success({
              rowData: ExemptVendorTypes,
              rowCount: exemptVendorTypeCount
            });
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
